module.exports = __webpack_public_path__ + "static/5-fe8dbd1178c748212b59467f8c1eb34d.jpg";